import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { BasicSectionTitle } from 'Components/Blocks/Titles'
import { Column } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import Benefits from './Benefits'
import Questions from './Questions'

type Props = {
  onAction?: () => void
}

function EmajinMembershipsSection({ onAction }: Props) {
  return (
    <SectionContainer>
      <AppearingWrapper centered>
        <Column fullWidth>
          <Column alignCenter fullWidth mb={7} px={LANDING_CONTENT_PX}>
            <Column
              fullWidth
              gap={10}
              maxWidth={LANDING_CONTENT_WIDTH_PX}
              pt={64}
            >
              <BasicSectionTitle
                buttonCaption="Contact Us"
                plainText="Packages you won’t even notice on your balance sheet, but ROI you’ll thank yourself for."
                subtitle="Membership Options"
                title="emajin"
                onClick={onAction}
              />
            </Column>
          </Column>

          <Questions onAction={onAction} />

          <Benefits />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default EmajinMembershipsSection
